// Disclaimer.js
import React from 'react';
import '.././styles.css';

const Disclaimer = () => {
  return (
    <div className="legal-links">
      <h1>Disclaimer</h1>
      <p>
        The information provided on GETFITFAST is for informational purposes only and is intended to enhance general awareness and understanding of health and fitness topics. While we strive to ensure the accuracy and reliability of the content, users are encouraged to verify the information independently and consult professionals when necessary.
      </p>
      
      <p>
        GETFITFAST is not a substitute for professional advice, diagnosis, or treatment. Always seek the guidance of a qualified healthcare provider for specific medical or health-related issues. 
      </p>
      
      <p>
        The content and materials provided on this website are based on publicly available information and sources. We make efforts to ensure that all content is original and does not infringe upon the intellectual property rights of others. If you believe any content on this site may violate such rights, please contact us immediately for resolution.
      </p>
      
      <p>
        By using this website, you acknowledge that GETFITFAST is not responsible for any actions you take based on the information provided. Your use of the site signifies your agreement to our terms and policies.
      </p>
    </div>
  );
};

export default Disclaimer;
